import { HttpClient } from "@angular/common/http";
import { map, catchError } from "rxjs";
import { httpOptionsDefault } from "../../_shared/constants";
import { PaymentResult } from "../../_shared/models/PaymentResult";
import { WebApiService } from "../WebApiService";



export class CieloController {
  constructor(public _http: HttpClient, private _webApi: WebApiService) {
  }
  pay(schemeId: number, orderId: number, paymentId: number): Promise<PaymentResult> {



    return this._http.get(this._webApi.GetApiAddress() + `/cielo/payScheme/${schemeId}/${orderId}/${paymentId}`, httpOptionsDefault)
      .pipe(
        map(result => {


          return result;
        }

        ),
        catchError(error => {

          return error;
        })
      )
      .toPromise().then((result: PaymentResult) => {


        return result;
      });

  }



}

